var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPurpleLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1306 3.625V20.125C17.1306 21.9713 18.4075 23 19.7622 23C21.0153 23 22.3937 22.125 22.3937 20.125V3.75C22.3937 2.0575 21.1406 1 19.7622 1C18.3837 1 17.1306 2.16625 17.1306 3.625Z",
    fill: "#8CABFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2383 12.0001V20.1251C10.2383 21.9714 11.5152 23.0001 12.8699 23.0001C14.123 23.0001 15.5015 22.1251 15.5015 20.1251V12.1251C15.5015 10.4326 14.2483 9.37512 12.8699 9.37512C11.4914 9.37512 10.2383 10.5414 10.2383 12.0001Z",
    fill: "#4E75E1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.97756 23.0001C7.43094 23.0001 8.60915 21.8249 8.60915 20.3751C8.60915 18.9254 7.43094 17.7501 5.97756 17.7501C4.52417 17.7501 3.34596 18.9254 3.34596 20.3751C3.34596 21.8249 4.52417 23.0001 5.97756 23.0001Z",
    fill: "#4E75E1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurpleLogo);
export default __webpack_public_path__ + "static/media/purple-logo.4fcfcc760190285aa003a49c16d0109e.svg";
export { ForwardRef as ReactComponent };